import React from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery'

import MUIDataTable from 'mui-datatables'

class CountryList extends React.Component {
  state = {
    country_data: [],
  }
  handleStatusChange = (sid) => {
    var isChecked = $('#coutry_status_' + sid)
    isChecked.prop('checked', !isChecked.prop('checked'))
  }

  deleteCountry = () => {}
  componentDidMount() {}

  render() {
    const columns = [
      {
        name: 'ctryName',
        label: 'Country Name : English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'ctryNameAr',
        label: 'Country Name : Arabic',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: '',
        label: 'Currency',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: '',
        label: 'Tel Code',
        options: {
          filter: true,
          sort: true,
        },
        // }, {
        //   name: "active",
        //   label: "Status",
        //   options: {
        //     filter: true,
        //     sort: true,
        //     customBodyRender: (active, tableMeta) => {
        //       var country_id = tableMeta.rowData[1];
        //       return <Toggle
        //         id={"coutry_status_" + country_id}
        //         checked={active}
        //         value={active}
        //         onChange={this.handleStatusChange.bind(this, country_id)}
        //       />
        //     }

        //   }
      },
      {
        name: 'ctryID',
        label: 'Action',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (ctryID) => {
            return (
              <div>
                <Link
                  to={'/country/add/' + ctryID}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteCountry.bind(this, ctryID)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Country Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Country List</h4>
                    </div>
                  </div>
                  <Link
                    to="/country/add"
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i> Add Country
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Country List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Country List'}
                          className="table-responsive"
                          data={this.state.country_data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CountryList
